module.exports = __webpack_public_path__ + "media/9.8b3a2b22.mp3";